import { render, staticRenderFns } from "./PresencePickupResponsibles.vue?vue&type=template&id=0d5d6f7b&scoped=true&"
import script from "./PresencePickupResponsibles.vue?vue&type=script&lang=js&"
export * from "./PresencePickupResponsibles.vue?vue&type=script&lang=js&"
import style0 from "./PresencePickupResponsibles.vue?vue&type=style&index=0&id=0d5d6f7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d6f7b",
  null
  
)

export default component.exports